// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"c6938394","988":"61e9df80"}[chunkId] + ".chunk.js";
};